var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6Pos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.37 32.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".yellow{fill:currentColor;}.black{fill:#2f2e2b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M15.64,13.37H5V7.6H15.64ZM6.34,12h7.93V9H6.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow",
    x: 20.51,
    y: 27.32,
    width: 3.08,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow",
    x: 14.79,
    y: 27.32,
    width: 3.08,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow",
    x: 20.51,
    y: 23.47,
    width: 3.08,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow",
    x: 14.79,
    y: 23.47,
    width: 3.08,
    height: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M24.77,16.75H23.24V16a.69.69,0,1,0-1.37,0v.78h-2V5.59h0V4.22H17.49c-.33-.07-.69-.66-.69-1.41s.38-1.38.73-1.42h2.39V0H17.5L2.59.08A2.61,2.61,0,0,0,0,2.67v.25H0V24.21A2.61,2.61,0,0,0,2.6,26.8H11v3.08a2.61,2.61,0,0,0,2.59,2.6H24.78a2.62,2.62,0,0,0,2.59-2.6V19.35A2.62,2.62,0,0,0,24.77,16.75Zm-2.9,1.37V19a.69.69,0,1,0,1.37,0v-.86h1.53A1.24,1.24,0,0,1,26,19.35V20H12.39v-.66a1.24,1.24,0,0,1,1.22-1.23h1.53V19a.69.69,0,1,0,1.37,0v-.86ZM1.37,2.68A1.23,1.23,0,0,1,2.6,1.45l13.12-.06a3.51,3.51,0,0,0-.29,1.41,3.46,3.46,0,0,0,.29,1.4L2.6,4.14A1.23,1.23,0,0,1,1.37,2.93ZM11,25.43H2.6a1.23,1.23,0,0,1-1.23-1.22v-.49H11Zm0-6.08v3H1.37V5.19a2.55,2.55,0,0,0,1.22.32l14.85.07.12,0v0h1V16.75h-2V16a.69.69,0,1,0-1.37,0v.78H13.61A2.61,2.61,0,0,0,11,19.35ZM24.77,31.11H13.61a1.23,1.23,0,0,1-1.22-1.23v-8.5H26v8.5A1.23,1.23,0,0,1,24.77,31.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Pos);
export default __webpack_public_path__ + "static/media/6-pos.f84e6fbe.svg";
export { ForwardRef as ReactComponent };